import { render, staticRenderFns } from "./RankingQuotaEditor.vue?vue&type=template&id=6d7e75a4&scoped=true&"
import script from "./RankingQuotaEditor.vue?vue&type=script&lang=js&"
export * from "./RankingQuotaEditor.vue?vue&type=script&lang=js&"
import style0 from "./RankingQuotaEditor.vue?vue&type=style&index=0&id=6d7e75a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7e75a4",
  null
  
)

export default component.exports